import { Button, Grid, Paper, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import personal_space from '../../../assets/images/personal_space.png';

/**
 * Composant informations espace usagers
 * @constructor
 */
export default function PersonalSpaceUi() {
    // Création de la page
    return (
        <Paper elevation={3} style={{ height: '100%' }}>
            <Grid container justifyContent="center" style={{ padding: 20 }}>
                {/*Affichage de l'image*/}
                <Grid item>
                    <img style={{ width: '150px' }} src={personal_space} alt="Espace usagers" />
                </Grid>
                <Grid item xs={12}>
                    <hr />
                </Grid>
                {/*Affichage du bloc espace usagers*/}
                <Grid item>
                    <Typography style={{ textAlign: 'center' }} variant="h5">
                        Espace usagers
                    </Typography>
                    <Typography variant="body1">
                        Simplifiez-vous la gestion de vos contrats, en utilisant votre Espace Usagers pour toutes vos
                        demandes.
                    </Typography>
                    {/*Bouton pour l'accès à l'espace usagers*/}
                    <Typography style={{ textAlign: 'center' }}>
                        <Button component={Link} to="/" variant="contained">
                            Accédez à votre espace usagers
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );
}
